const initialState = {
  messages: [],
};


const getters = {
  getMessages(state) {
    return state.messages;
  },
};

const mutations = {
  setMessages(state, data) {
    state.messages = data;
  },
  addMessage(state, data) {
    state.messages.unshift(data);
  },
  deleteMessage(state, messageId) {
    const messageIndex = state.messages.findIndex((element) => {
      /* eslint-disable */
      if (element._id == messageId) {
        return true;
      }
      return false;
    });
    state.messages.splice(messageIndex, 1);
  },
};

const actions = {
};


export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/modules/Dashboard/modules/chat.js